module.exports = __webpack_public_path__ + "static/media/circle.5edb7000.ogg";